import { useContext } from "react";
import { onlineStatusStore } from "../contexts/OnlineStatusContext";

const useOnlineStatus = (): boolean => {
  return useContext(onlineStatusStore);
};

export default useOnlineStatus;
